module.exports = __webpack_public_path__ + "static/img/picture3.7b6e2d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swipe/picture3.jpg
// module id = GVgK
// module chunks = 0